import axios from 'axios';
import api from './ApiService';

export async function getSearch(filters : any): Promise<any> {
  try {
    const response = await api.post('/search', filters);
    return response.data;
  } catch (error) {
    console.error('Erro ao realizar a pesquisa', error);
    throw new Error('Erro ao realizar a pesquisa');
  }
}
